<script>
import AppHeader from "@/components/Essentials/AppHeader.vue";
import AppFooter from "@/components/Essentials/AppFooter.vue";
import Fastnav from "@/components/Home/FastNav/Fastnav.vue";
import RC from "@/components/Decores/RC.vue";

export default {
  name: "DecoresPage",
  components : {
    RC,
    Fastnav,
    AppFooter,
    AppHeader

  }
}
</script>

<template>
  <AppHeader></AppHeader>
  <RC></RC>
  <Fastnav></Fastnav>
  <AppFooter></AppFooter>
</template>
